import { Injectable } from '@angular/core';
import {PathStore} from "../store/path.store";
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PosizioniJobService {

  constructor(
    private path: PathStore,
    private http: HttpClient
  ) { }

  startPosizioniJob(codiceFiscale: string, codiceIpaEnte: string, uidUtente: string, email: string): Observable<void> {
    const url = `${this.path.baseURLPosizioni}/service/posizionijob/${codiceFiscale}/${codiceIpaEnte}/${uidUtente}`;
    const payload = {
      email: email
    }
    return this.http.post<void>(url, payload);
  }
  endPosizioniJob(codiceFiscale: string, codiceIpaEnte: string): Observable<void> {
    const url = `${this.path.baseURLPosizioni}/service/posizionijob/${codiceFiscale}/${codiceIpaEnte}`;
    return this.http.delete<void>(url, {});
  }
}
